export const CANDIDATE_DASHBOARD_LINKS = {
  candidate: '/candidate',
  introduction: '/candidate/introduction',
  shares: {
    home: '/candidate/shares',
    newInvite: '/candidate/shares/newinvite',
  },
  preferences: '/candidate/preferences',
};

export const DEFAULT_EXPERIENCE_TYPE_ID = 2;

export const getVanityLinkDomain = () => {
  const rootUrl = window.location.origin.split('//')[1];
  switch (rootUrl) {
    case 'staging-fe.searchlight.ai':
    case 'my.searchlight.ai':
    case 'app.searchlight.ai':
    case 'preview.searchlight.ai':
      return 'https://my.searchlight.ai';
    case 'localhost:3000':
      return 'http://localhost:3000';
    default:
      return 'https://latest-vanity.searchlight.ai';
  }
};
